var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-2"},[_c('v-card',{staticClass:"mt-2"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('CashieringDataTable')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }